
import { Component, Vue } from 'vue-property-decorator'
import User from '@/types/user'
import NotificationCenter from '@/components/base/NotificationCenter.vue'
import SearchWidget from '@/components/dashboard/SearchWidget.vue'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { SearchWidget, NotificationCenter }
})

export default class HeaderBar extends Vue {
  $refs!: {
    searchWidget?: SearchWidget
  }

  showSearchModal = false

  toggleCollapsed () : void {
    this.$store.dispatch('toggleNavigation')
  }

  toggleSearchModal () : void {
    this.showSearchModal = !this.showSearchModal

    if (this.showSearchModal) {
      this.focusSearchWidget()
    }
  }

  closeSearchModal () : void {
    this.showSearchModal = false
  }

  focusSearchWidget () : void {
    this.$nextTick(() => {
      window.setTimeout(() => {
        if (this.showSearchModal && this.$refs.searchWidget) {
          this.$refs.searchWidget.focusInput()
        }
      }, 150)
    })
  }

  navigateTo (a:{key:string}) : void {
    if (this.$route.name !== a.key && a.key !== 'logout') {
      this.$router.push({ name: a.key })
    }
  }

  logout () : void {
    this.$store.dispatch('authStore/logout')
  }

  get canSeeReleases () : boolean {
    return can('releases.view') || can('releases.edit')
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get showDropdown () : boolean {
    return can('companies.view') || can('users.view') || can('roles.view')
  }

  get authUser () : User {
    return this.$store.getters['authStore/authUser']
  }
}
